module.exports = __webpack_public_path__ + "img/device_marker.7ec378a1.png";